// import React, { useState, useContext, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import styled, { keyframes } from "styled-components";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";

// const MergedPassportForm = () => {
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);

//   const [formType, setFormType] = useState("fresh"); // 'fresh' or 'reissue'
//   const [step, setStep] = useState(1);

//   const [formData, setFormData] = useState({
//     name: "",
//     contactNo: "",
//     emergencyContact: "",
//     email: user?.email || "",
//     education: "",
//     profession: "",
//     placeOfBirth: "",
//     policeStation: "",
//     motherName: "",
//     fatherName: "",
//     spouseName: "",
//     aadhaarCard: null,
//     panCard: null,
//     anyDocument: null,
//     birthCertificate: null,
//     passportPhotoFront: null,
//     passportPhotoBack: null,
//     marksheetfile: null,
//   });

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: files ? files[0] : value,
//     }));
//   };

//   useEffect(() => {
//     if (formType === "fresh" && user?.email) {
//       axios
//         .get(`http://localhost:5000/api/fresh-passport/check/${user.email}`)
//         .then((res) => {
//           if (res.data.limitReached) {
//             alert("You have already submitted 5 applications. Limit reached.");
//             navigate("/UserProfile");
//           }
//         })
//         .catch((err) => console.error(err));
//     }
//   }, [formType, user]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!user?.email) return alert("Login required to submit");

//     const applicationId = Math.floor(
//       100000 + Math.random() * 900000
//     ).toString();

//     const combinedData = {
//       ...formData,
//       email: formData.email || user.email,
//       userEmail: user.email,
//       applicationId,
//       aadhaarCard: formData.aadhaarCard?.name || null,
//       panCard: formData.panCard?.name || null,
//       anyDocument: formData.anyDocument?.name || null,
//       birthCertificate: formData.birthCertificate?.name || null,
//       passportPhotoFront: formData.passportPhotoFront?.name || null,
//       passportPhotoBack: formData.passportPhotoBack?.name || null,
//       marksheetfile: formData.marksheetfile?.name || null,
//     };

//     const dataToSend = new FormData();
//     dataToSend.append("applicationData", JSON.stringify(combinedData));

//     const fileFields = [
//       "aadhaarCard",
//       "panCard",
//       "anyDocument",
//       "birthCertificate",
//       "passportPhotoFront",
//       "passportPhotoBack",
//       "marksheetfile",
//     ];

//     fileFields.forEach((field) => {
//       if (formData[field]) dataToSend.append(field, formData[field]);
//     });

//     try {
//       const endpoint =
//         formType === "fresh"
//           ? "http://localhost:5000/api/fresh-passport"
//           : "http://localhost:5000/api/reissue-passport";
//       const res = await axios.post(endpoint, dataToSend, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       alert(`Application submitted! ID: ${res.data.applicationId}`);
//       navigate("/Payments");
//     } catch (error) {
//       alert("Submission failed");
//       console.error(error);
//     }
//   };

//   return (
//     <Container>
//       <h1>Passport Application</h1>
//       <Label>Select Application Type:</Label>
//       <select value={formType} onChange={(e) => setFormType(e.target.value)}>
//         <option value="fresh">Fresh Passport</option>
//         <option value="reissue">Reissue Passport</option>
//       </select>

//       <form onSubmit={handleSubmit} encType="multipart/form-data">
//         {step === 1 && (
//           <>
//             <Label>Full Name</Label>
//             <Input name="name" required onChange={handleChange} />

//             <Label>Contact Number</Label>
//             <Input name="contactNo" required onChange={handleChange} />

//             <Label>Emergency Contact</Label>
//             <Input name="emergencyContact" required onChange={handleChange} />

//             <Label>Education</Label>
//             <Input name="education" required onChange={handleChange} />

//             <Label>Profession</Label>
//             <Input name="profession" required onChange={handleChange} />

//             {formType === "fresh" && (
//               <>
//                 <Label>Place of Birth</Label>
//                 <Input name="placeOfBirth" required onChange={handleChange} />
//               </>
//             )}

//             <Label>Police Station</Label>
//             <Input name="policeStation" required onChange={handleChange} />

//             <Button type="button" onClick={() => setStep(2)}>
//               Next
//             </Button>
//           </>
//         )}

//         {step === 2 && (
//           <>
//             {formType === "fresh" && (
//               <>
//                 <Label>Mother's Name</Label>
//                 <Input name="motherName" required onChange={handleChange} />

//                 <Label>Father's Name</Label>
//                 <Input name="fatherName" required onChange={handleChange} />

//                 <Label>Spouse's Name</Label>
//                 <Input name="spouseName" onChange={handleChange} />
//               </>
//             )}

//             <Label>Email</Label>
//             <Input
//               name="email"
//               type="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//             />

//             <Label>Aadhaar Card</Label>
//             <Input
//               type="file"
//               name="aadhaarCard"
//               onChange={handleChange}
//               required
//             />

//             <Label>PAN Card</Label>
//             <Input
//               type="file"
//               name="panCard"
//               onChange={handleChange}
//               required
//             />

//             {formType === "reissue" && (
//               <>
//                 <Label>Any Document (TC, Bank Passbook)</Label>
//                 <Input type="file" name="anyDocument" onChange={handleChange} />

//                 <Label>Birth Certificate (if child)</Label>
//                 <Input
//                   type="file"
//                   name="birthCertificate"
//                   onChange={handleChange}
//                 />

//                 <Label>Passport Photo (Front)</Label>
//                 <Input
//                   type="file"
//                   name="passportPhotoFront"
//                   onChange={handleChange}
//                   required
//                 />

//                 <Label>Passport Photo (Back)</Label>
//                 <Input
//                   type="file"
//                   name="passportPhotoBack"
//                   onChange={handleChange}
//                   required
//                 />
//               </>
//             )}

//             {formType === "fresh" && (
//               <>
//                 <Label>Marksheet / Birth Certificate</Label>
//                 <Input
//                   type="file"
//                   name="marksheetfile"
//                   onChange={handleChange}
//                 />
//               </>
//             )}

//             <Button type="button" onClick={() => setStep(1)}>
//               Back
//             </Button>
//             <Button type="submit">Submit</Button>
//           </>
//         )}
//       </form>
//     </Container>
//   );
// };

// export default MergedPassportForm;

// const Container = styled.div`
//   max-width: 700px;
//   margin: 2rem auto;
//   padding: 2rem;
//   background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
//   color: #e6e6e6;
//   border: 1px solid #353535;
//   border-radius: 8px;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 0.75rem;
//   margin-bottom: 1rem;
//   background: transparent;
//   border: 1px solid #444;
//   border-radius: 4px;
//   color: white;
//   &:focus {
//     border-color: #3f51ff;
//     outline: none;
//   }
// `;

// const Label = styled.label`
//   margin-bottom: 0.5rem;
//   display: block;
// `;

// const Button = styled.button`
//   padding: 0.75rem 1.5rem;
//   margin: 0.5rem;
//   background: linear-gradient(90deg, #194bfd, #ad13fb);
//   border: none;
//   border-radius: 4px;
//   color: white;
//   cursor: pointer;
// `;

import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const MergedPassportForm = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [formType, setFormType] = useState("fresh"); // 'fresh' or 'reissue'
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    name: "",
    contactNo: "",
    emergencyContact: "",
    email: user?.email || "",
    education: "",
    profession: "",
    placeOfBirth: "",
    policeStation: "",
    motherName: "",
    fatherName: "",
    spouseName: "",
    aadhaarCard: null,
    panCard: null,
    anyDocument: null,
    birthCertificate: null,
    passportPhotoFront: null,
    passportPhotoBack: null,
    marksheetfile: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  useEffect(() => {
    if (formType === "fresh" && user?.email) {
      axios
        .get(`http://localhost:5000/api/fresh-passport/check/${user.email}`)
        .then((res) => {
          if (res.data.limitReached) {
            alert("You have already submitted 5 applications. Limit reached.");
            navigate("/UserProfile");
          }
        })
        .catch((err) => console.error(err));
    }
  }, [formType, user]);

  const generateApplicationId = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const letters = Array.from(
      { length: 4 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
    const numbers = Math.floor(10000 + Math.random() * 90000); // 5-digit number
    return `${letters}${numbers}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user?.email) return alert("Login required to submit");

    const applicationId = generateApplicationId();

    const combinedData = {
      ...formData,
      email: formData.email || user.email,
      userEmail: user.email,
      applicationId,
      aadhaarCard: formData.aadhaarCard?.name || null,
      panCard: formData.panCard?.name || null,
      anyDocument: formData.anyDocument?.name || null,
      birthCertificate: formData.birthCertificate?.name || null,
      passportPhotoFront: formData.passportPhotoFront?.name || null,
      passportPhotoBack: formData.passportPhotoBack?.name || null,
      marksheetfile: formData.marksheetfile?.name || null,
    };

    console.log("📦 Submitted Data:", combinedData);

    const dataToSend = new FormData();
    dataToSend.append("applicationData", JSON.stringify(combinedData));

    const fileFields = [
      "aadhaarCard",
      "panCard",
      "anyDocument",
      "birthCertificate",
      "passportPhotoFront",
      "passportPhotoBack",
      "marksheetfile",
    ];

    fileFields.forEach((field) => {
      if (formData[field]) dataToSend.append(field, formData[field]);
    });

    try {
      const endpoint =
        formType === "fresh"
          ? "http://localhost:5000/api/fresh-passport"
          : "http://localhost:5000/api/reissue-passport";
      const res = await axios.post(endpoint, dataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert(`Application submitted! ID: ${res.data.applicationId}`);
      navigate("/Payments");
    } catch (error) {
      alert("Submission failed");
      console.error(error);
    }
  };

  return (
    <Container>
      <h1>Passport Application</h1>
      <Label>Select Application Type:</Label>
      <select value={formType} onChange={(e) => setFormType(e.target.value)}>
        <option value="fresh">Fresh Passport</option>
        <option value="reissue">Reissue Passport</option>
      </select>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        {step === 1 && (
          <>
            <Label>Full Name</Label>
            <Input name="name" required onChange={handleChange} />

            <Label>Contact Number</Label>
            <Input name="contactNo" required onChange={handleChange} />

            <Label>Emergency Contact</Label>
            <Input name="emergencyContact" required onChange={handleChange} />

            <Label>Education</Label>
            <Input name="education" required onChange={handleChange} />

            <Label>Profession</Label>
            <Input name="profession" required onChange={handleChange} />

            {formType === "fresh" && (
              <>
                <Label>Place of Birth</Label>
                <Input name="placeOfBirth" required onChange={handleChange} />
              </>
            )}

            <Label>Police Station</Label>
            <Input name="policeStation" required onChange={handleChange} />

            <Button type="button" onClick={() => setStep(2)}>
              Next
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            {formType === "fresh" && (
              <>
                <Label>Mother's Name</Label>
                <Input name="motherName" required onChange={handleChange} />

                <Label>Father's Name</Label>
                <Input name="fatherName" required onChange={handleChange} />

                <Label>Spouse's Name</Label>
                <Input name="spouseName" onChange={handleChange} />
              </>
            )}

            <Label>Email</Label>
            <Input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <Label>Aadhaar Card</Label>
            <Input
              type="file"
              name="aadhaarCard"
              onChange={handleChange}
              required
            />

            <Label>PAN Card</Label>
            <Input
              type="file"
              name="panCard"
              onChange={handleChange}
              required
            />

            {formType === "reissue" && (
              <>
                <Label>Any Document (TC, Bank Passbook)</Label>
                <Input type="file" name="anyDocument" onChange={handleChange} />

                <Label>Birth Certificate (if child)</Label>
                <Input
                  type="file"
                  name="birthCertificate"
                  onChange={handleChange}
                />

                <Label>Passport Photo (Front)</Label>
                <Input
                  type="file"
                  name="passportPhotoFront"
                  onChange={handleChange}
                  required
                />

                <Label>Passport Photo (Back)</Label>
                <Input
                  type="file"
                  name="passportPhotoBack"
                  onChange={handleChange}
                  required
                />
              </>
            )}

            {formType === "fresh" && (
              <>
                <Label>Marksheet / Birth Certificate</Label>
                <Input
                  type="file"
                  name="marksheetfile"
                  onChange={handleChange}
                />
              </>
            )}

            <Button type="button" onClick={() => setStep(1)}>
              Back
            </Button>
            <Button type="submit">Submit</Button>
          </>
        )}
      </form>
    </Container>
  );
};

export default MergedPassportForm;

const Container = styled.div`
  max-width: 700px;
  margin: 2rem auto;
  padding: 2rem;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  color: #e6e6e6;
  border: 1px solid #353535;
  border-radius: 8px;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background: transparent;
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  display: block;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  margin: 0.5rem;
  background: linear-gradient(90deg, #194bfd, #ad13fb);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
`;
